module.exports = __webpack_public_path__ + "static/media/graph3.64467251.svg";